import React, { Component, useEffect, useState } from 'react';
import { Helper } from '../../../src/ToolKit/toolkit.js';
import { DataClass, enums } from '../../../src/ToolKit/DataClass.js'

import $ from 'jquery/dist/jquery';
import { Menu, ColumnType, Action, AlertD, YesNo, DropDownBox, SelectBasic, DayTimeSelector, FormDiv, InputBox, Icon, SideView, SideItem, FilterView, SpecValues, ProTable, SimpleButton, CustomHelper, FixedMessage, Captia, Column, NewRecordValue, FromBasic, AddButton, FileProgess, LoadingBar, FromSubmit, InputTextBox, InputPasswordBox, Model, Confirm, RowState } from '../.././Componet';
import { useParams } from "react-router-dom";
import { Route } from "react-router-dom";
import { Modal } from 'bootstrap';
import { data } from 'jquery';



class EnvVarMgt extends React.Component {
    constructor(props) {
        super(props);
        this.props = props;
        this.state = { isLoaded: false, Record: [] };
        this.submit = this.submit.bind(this);
    }
    componentDidMount() {
        let cmd = this;
        let hlp = new Helper();
        hlp.Ajax("EnvVar", "List", {}, function (datas) {
            cmd.setState({ isLoaded: true, Records: datas });

        }, function () { });

    }
    submit() {
        let h = new Helper();
        h.Validate();
        if (h.isValidate() == false) {
            return;
        }
        let data = h.GetDataGrouped(window.EnvVars);
        h.Ajax('EnvVar', 'SaveBatch', { Inserted: data[RowState.Inserted], Updated: data[RowState.Changed], deleted: data[RowState.Deleted] }
            , function (data) {
                h.MessageBox(FixedMessage.NoProblem, FixedMessage.Result);
                h.GoBack();
            },
        )
    }
    render() {
        if (this.state.isLoaded == false) {
            return LoadingBar();
        }
        else {
            return <FromSubmit SubmitButtonOnTop={true} submitBev={this.submit} >
                <ProTable datasourcename='EnvVars' Records={this.state.Records} Insertable={true} Deleteable={true}>
                    <Column metaForInput={DataClass.EnvVar.Name} />
                    <Column metaForInput={DataClass.EnvVar.Caption} />
                    <Column metaForInput={DataClass.EnvVar.Value} />

                </ProTable>

            </FromSubmit>

        }

    }


}
class InputParameterMgt extends React.Component {
    constructor(props) {
        super(props);
        this.props = props;
        this.state = { isLoaded: false, Record: [] };
        this.submit = this.submit.bind(this);
    }
    componentDidMount() {
        let cmd = this;
        let hlp = new Helper();
        hlp.Ajax("InputParameter", "List", {}, function (datas) {
            cmd.setState({ isLoaded: true, Records: datas });

        }, function () { });

    }
    submit() {
        let h = new Helper();
        h.Validate();
        if (h.isValidate() == false) {
            return;
        }
        let data = h.GetDataGrouped(window.InputParameters);
        h.Ajax('InputParameter', 'SaveBatch', { Inserted: data[RowState.Inserted], Updated: data[RowState.Changed], deleted: data[RowState.Deleted] }
            , function (data) {
                h.MessageBox(FixedMessage.NoProblem, FixedMessage.Result);
                h.GoBack();
            },
        )
    }
    render() {
        if (this.state.isLoaded == false) {
            return LoadingBar();
        }
        else {
            return <FromSubmit SubmitButtonOnTop={true} submitBev={this.submit} >
                <ProTable datasourcename='InputParameters' Records={this.state.Records} Insertable={true} Deleteable={true}>
                    <Column metaForDisplay={DataClass.InputParameter.id} />
                    <Column metaForInput={DataClass.InputParameter.enName} />
                    <Column metaForInput={DataClass.InputParameter.faName} />
                    <Column metaForInput={DataClass.InputParameter.type} />
                    <Column metaForInput={DataClass.InputParameter.targetLength} />
                    <Column metaForInput={DataClass.InputParameter.rangeValues} />

                </ProTable>

            </FromSubmit>

        }

    }


}

export class BaseLetterMgt extends React.Component {
    constructor(props) {
        super(props);
        this.props = props;
        this.state = ({ isLoaded: false, Records: [] });
        this.Delete = this.Delete.bind(this);
        this.Refersh = this.Refersh.bind(this);

    }

    Delete(record) {
        let hlp = new Helper();
        let cmd = this;
        hlp.ConfirmAction(FixedMessage.AreYouSure, '', function () {
            hlp.Ajax('BaseLetter', 'Delete', { Model: record }, function (data) {
                cmd.componentDidMount();
                hlp.MessageBox(data.message, FixedMessage.Result);
            });
        });
    }

    Refersh() {
        let cmd = this;
        let h = new Helper();
        h.Ajax('BaseLetter', 'List', {}, function (data) {
            cmd.setState({ isLoaded: true, Records: data });
        });
    }

    componentDidMount() {
        this.Refersh();
    }

    render() {
        if (this.state.isLoaded == false) {
            return LoadingBar();

        }
        else {
            return <FromBasic staticTitle=''>
                <AddButton title='' entity='BaseLetter' /> <ProTable Records={this.state.Records} datasourcename='BaseLetters'>
                    <Column metaForDisplay={DataClass.BaseLetter.id} />
                    <Column metaForDisplay={DataClass.BaseLetter.name} />
                    <Column metaForDisplay={DataClass.BaseLetter.description} />
                    <Action caption="ایجاد نامه" type="Link" pageName="/BaseLetter/CreateLetter" columnName='id' />

                    <Action caption="ویرایش" type="Link" pageName="/BaseLetter/Edit" columnName='id' />


                    <Action caption="حذف" type="function" targetFun={this.Delete} />




                </ProTable>
            </FromBasic>
        }
    }



}


/* دریافت تمامی رکورد ها */
  



/* ویرایش */
function EditBaseLetter() {
    const queryS = useParams();
    return <AddBaseLetter id={queryS.id} />
}

/* درج و و یرایش رکورد */


export class AddBaseLetter extends React.Component {
    constructor(props) {
        super(props);
        this.props = props;
        this.id = props.id;
        this.submit = this.submit.bind(this);
        this.state = ({useableParameter:[]});
    }
    submit() {
        let h = new Helper();
        let cmd = this;
        h.Validate();
        if (h.isValidate() == false) {
            return;
        }
        let id = (cmd.id == undefined ? -1 : cmd.id);
        let o = h.GetPostData();
        h.Ajax('BaseLetter', (cmd.id == '-1' ? 'Insert' : 'Update'), { Model: o, id: id }, function (data) {
            if (data.status == 200) {
                h.MessageBox(data.message, FixedMessage.Result);
                h.GoBack();
            }
            else {
                h.Error(data.message, FixedMessage.Result);

            }
        });
        
    }
    componentDidMount() {
        let h = new Helper();
        let cmd = this;
        if (this.id != -1) {
            h.Ajax('BaseLetter', 'Get', { id: this.id }, function (data) {
                h.SetDataBack(data);
            });


        }
        h.Ajax('BaseLetter', 'GetAllVar', {}, (data) => {
            cmd.setState({ useableParameter: data });
        });
    }
    listAllParameter(targetId) {
        return <FormDiv size="100%">
            <center>
                {this.state.useableParameter.map((e) => {
                    return <SimpleButton title={e.caption} onClick={() => {
                        if (targetId != 'txtGenContext') {
                            document.getElementById(targetId).setRangeText(e.nameDeclareFormat);

                        }
                        else {
                            window.tinymce.activeEditor.insertContent('<span>' + e.nameDeclareFormat +'</span>');
                        }
                        
                     
                    }}></SimpleButton>

                })}
            </center>

        </FormDiv>
    }

    render() {
        return <FromSubmit submitBev={this.submit}>
            
            <InputBox meta={DataClass.BaseLetter.name} size='100%' />
            <InputBox meta={DataClass.BaseLetter.description} size='100%' />
            {this.listAllParameter('txtGenName')}
            <InputBox meta={DataClass.BaseLetter.GenName} size='100%' />
            {this.listAllParameter('txtGenContext')}
            <InputBox meta={DataClass.BaseLetter.GenContext} customHelper={CustomHelper.Html} size='100%' />


        </FromSubmit>

    }

}

function CreateLetter(props) {
    let id = useParams().id;

    return <StartRequest id={id} />;
}

class StartRequest extends React.Component {
    constructor(props) {
        super(props);
        this.props = props;
        this.id = props.id;
        this.copyMode = props.copyMode;
        this.submit = this.submit.bind(this);
        this.loadData = this.loadData.bind(this);
        this.state = { loaded: false,letNo:'', para: [], title: 'در حال دریافت...' }
    }
    submit(preview) {
        let h = new Helper();
        h.Validate();
        if (h.isValidate()) {
            let obj = h.GetPostData();
            let data = new Object();
            data.id = this.id;
            data.paras = [];
         
            data.letNo = obj.letNo;
            let keys = Object.keys(obj);
            for (let i = 0; i < keys.length; i++) {
                data.paras.push({ key: keys[i], value: obj[keys[i]] });
            }
            data.id = this.props.id;
            let cmd = this;
            data.preview = preview;
            h.Ajax('BaseLetter', 'CreateLetter', data, function (data) {

                if (preview) {
                    let w = window.open('');
                    let urlx = window.location.toString().replace(window.location.pathname, '');
                    //w.document.head.innerHTML = '  <link rel="stylesheet" href="' + urlx + '/css/styleSheet.css?id=740da72b-8bba-4c46-8276-8ecaa7e03a09" />'
                    w.document.body.innerHTML = data.refId;

                }
               
                if (data.status == '200') {
                    if (preview == false) {
                        h.MessageBox(data.message, 'اطلاعات');
                        h.GoBack();
                    }
                    else {
                        h.ConfirmAction("آیا نامه ثبت گردد؟", "پرسش", () => {
                            cmd.submit(false);
                        })
           
                    }
               
                }
             

            });
        }

    }
    loadData() {
   
        $('#txtLetNo').val(this.state.letNo)
    }


    componentDidMount() {
        let h = new Helper();

        let cmd = this;
        if (this.state.loaded == false) {
          
            h.Ajax('BaseLetter', 'GetParameterforRequest', { id: this.id }, function (data) {
                cmd.setState({ para: data.parameters, letNo: data.letNum, loaded: true, title: data.title });
                    cmd.id = data.id;
                cmd.values = data.values;
                    
                    window.setTimeout(cmd.loadData, 500);
                })
            }

         
    }

      PrintMode(id) {
        let hlp = new Helper();


        hlp.Ajax('Letter', 'Get', { id: id }, function (data) {
            let w = window.open('');
            let urlx = window.location.toString().replace(window.location.pathname, '');
            //w.document.head.innerHTML = '  <link rel="stylesheet" href="' + urlx + '/css/styleSheet.css?id=740da72b-8bba-4c46-8276-8ecaa7e03a09" />'
            w.document.body.innerHTML = data.context;

        });


    };
    setBlurEvent(e) {
        var ex = document.getElementsByTagName('input');
        for (let i = 0; i < ex.length; i++) {
            ex[i].onblur = (e) => {
                let cq = e.target.getAttribute('columnName');
                var btn = document.getElementById('btn' + cq);
                if (btn != null) {
                    btn.click();
                }
            };
        }
    }

    render() {
        let inputs = [];
        let querybtn = []
        for (let i = 0; i < this.state.para.length; i++) {
            let cpar = this.state.para[i];
            let cus = new Object();
            cus.mustFill = 'Yes';
            cus.caption = cpar.faName;
            cus.columnName = cpar.enName;
            cus.size = '33%';
            if (cpar.targetLength != 0) {
                cus.minlength = cpar.targetLength;
                cus.maxlength = cpar.targetLength;
            }
            if (cpar.type == '4') {
                cus.customHelper = CustomHelper.isDate;
            }
            if (cpar.type == '3') {
                cus.customHelper = CustomHelper.isDigitngGroupedNumber;
            }
            if (cpar.type == '2') {
                cus.customHelper = CustomHelper.LongText;
                cus.size = '100%';
            }
            if (cpar.type != '0') {

            }

            if (cpar.type != '5') {
                inputs.push(<InputTextBox {...cus} />)
            }
            else {
                let itms = cpar.rangeValues.split('\n');
                let so = [];
                for (let z = 0; z < itms.length; z++) {
                    so.push({ value: itms[z], caption: itms[z], unselectable: false });
                }

                cus.source = so;
                cus.includeAll = false;
                inputs.push(<SelectBasic {...cus} />);
            }
            
        }
       
        return <FromSubmit submitBev={() => { this.submit(true) }} staticTitle={this.state.title}>
            <FormDiv size='100%' >{this.state.title}</FormDiv>
            <InputBox meta={DataClass.Letter.LetNo} size="33%" />
            <hr/>
            
            {inputs}
        
         

        </FromSubmit>;
    }
}
function LetterSerach(props) {
    const [pageState, loadState] = useState({ records: [], isLoaded: false });


    const load = () => {
        let h = new Helper();
        h.Ajax('Letter', 'Serach', h.GetPostData(), (data) => {
            loadState({ records: data, isLoaded: true });
            window.Letters = data;
        });

    };
    const Delete = (record) => {
        let hlp = new Helper();
       
        hlp.ConfirmAction(FixedMessage.AreYouSure, '', function () {
            hlp.Ajax('Letter', 'Delete', { Model: record }, function (data) {
                load();
                hlp.MessageBox(data.message, FixedMessage.Result);
            });
        });

    };
    const Move = () => {

        let hlp = new Helper();

        hlp.ConfirmAction(FixedMessage.AreYouSure, '', function () {
            hlp.Ajax('Letter', 'MoveToFolder', { targetFolderId:$('#txtfolder').val(),Letters: hlp.GetRecordWithCircita(window.Letters,'selected',true) }, function (data) {
                load();
                hlp.MessageBox(data.message, FixedMessage.Result);
            });
        });

    }



    const PrintMode = (record) => {
        let hlp = new Helper();

      
        hlp.Ajax('Letter', 'Get', { id: record.id }, function (data) {
            let w = window.open('');
            let urlx = window.location.toString().replace(window.location.pathname, '');
            //w.document.head.innerHTML = '  <link rel="stylesheet" href="' + urlx + '/css/styleSheet.css?id=740da72b-8bba-4c46-8276-8ecaa7e03a09" />' 
            w.document.body.innerHTML = data.context;
                
            });
      

    };

    return <FromBasic>
        <InputTextBox caption="از تاریخ" size='33%' customHelper={CustomHelper.isDate} model="from" columnName="from" />
        <InputTextBox caption="تا تاریخ" size='33%' customHelper={CustomHelper.isDate} model="to" columnName="to" />
        <DropDownBox entity="Folder" includeAll={true} caption="پوشه" model="folder" columnName="folder" size="33%" />

        <InputTextBox caption="عنوان" size='33%' model="name" columnName="name" />
        <InputTextBox caption="شماره نامه" size='33%'  model="letNo" columnName="let"  />
        <InputTextBox caption="پارامتر ها" size='33%' model="parameter" columnName="parameter" />
       <center>
            <SimpleButton title="نمایش " Icon="View" onClick={load}></SimpleButton>
           <SimpleButton title="جا به جایی "  onClick={Move}></SimpleButton>
        </center>
         

        <ProTable Records={pageState.records} datasourcename='Letters'>
            <Column columnName="selected" type={ColumnType.InputCheck}  />    
            <Column metaForDisplay={DataClass.Letter.LetNo} />
    
            <Column metaForDisplay={DataClass.Letter.Name} />
            
            <Column metaForDisplay={DataClass.Letter.userName} />
         
            <Column metaForDisplay={DataClass.Letter.Paramters} />
            <Column metaForDisplay={DataClass.Letter.SaveTime} />
            <Action caption="ضمیمه" Icon="Cat" type="Link" pageName="/Attachs/Letter" columnName="id" />

            <Action caption="نسخه چاپی" type="function" targetFun={PrintMode} />
            <Action caption="ویرایش" type="Link" pageName="/Letter/Edit" columnName="id" />


            <Action caption="حذف" type="function" targetFun={Delete} />




        </ProTable>




    </FromBasic>


}

export class AddLetter extends React.Component {
    constructor(props) {
        super(props);
        this.props = props;
        this.id = props.id;
        this.submit = this.submit.bind(this);
    }
    submit() {
        let h = new Helper();
        let cmd = this;
        h.Validate();
        if (h.isValidate() == false) {
            return;
        }
        let id = (cmd.id == undefined ? -1 : cmd.id);
        let o = h.GetPostData();
        h.Ajax('Letter', (cmd.id == '-1' ? 'Insert' : 'Update'), { Model: o, id: id }, function (data) {
            if (data.status == 200) {
                h.MessageBox(data.message, FixedMessage.Result);
                h.GoBack();
            }
            else {
                h.Error(data.message, FixedMessage.Result);

            }
        });
    }
    componentDidMount() {
        let h = new Helper();
        if (this.id != -1) {
            h.Ajax('Letter', 'Get', { id: this.id }, function (data) {
                h.SetDataBack(data);
            });


        }
    }
    render() {
        return <FromSubmit submitBev={this.submit}>
           
    
            <InputBox meta={DataClass.Letter.Name} size='100%' />
            <InputBox meta={DataClass.Letter.Context} customHelper={CustomHelper.Html} size='100%' />
         


        </FromSubmit>

    }

}


function EditLetter() {
    const queryS = useParams();
    return <AddLetter id={queryS.id} />
}

class FolderMgt extends React.Component {
    constructor(props) {
        super(props);
        this.props = props;
        this.state = { isLoaded: false, Record: [] };
        this.submit = this.submit.bind(this);
    }
    componentDidMount() {
        let cmd = this;
        let hlp = new Helper();
        hlp.Ajax("Folder", "List", {}, function (datas) {
            cmd.setState({ isLoaded: true, Records: datas });

        }, function () { });

    }
    submit() {
        let h = new Helper();
        h.Validate();
        if (h.isValidate() == false) {
            return;
        }
        let data = h.GetDataGrouped(window.Folders);
        h.Ajax('Folder', 'SaveBatch', { Inserted: data[RowState.Inserted], Updated: data[RowState.Changed], deleted: data[RowState.Deleted] }
            , function (data) {
                h.MessageBox(FixedMessage.NoProblem, FixedMessage.Result);
                h.GoBack();
            },
        )
    }
    render() {
        if (this.state.isLoaded == false) {
            return LoadingBar();
        }
        else {
            return <FromSubmit SubmitButtonOnTop={true} submitBev={this.submit} >
                <ProTable datasourcename='Folders' Records={this.state.Records} Insertable={true} Deleteable={true}>
                    <Column metaForDisplay={DataClass.Folder.Id} />
                    <Column metaForInput={DataClass.Folder.Name} />

                </ProTable>

            </FromSubmit>

        }

    }


}
export class InLetterMgt extends React.Component {
    constructor(props) {
        super(props);
        this.props = props;
        this.state = ({ isLoaded: true, Records: [] });
        this.Delete = this.Delete.bind(this);
        this.Refersh = this.Refersh.bind(this);

    }

    Delete(record) {
        let hlp = new Helper();
        let cmd = this;
        hlp.ConfirmAction(FixedMessage.AreYouSure, '', function () {
            hlp.Ajax('InLetter', 'Delete', { Model: record }, function (data) {
                cmd.Refersh();
                hlp.MessageBox(data.message, FixedMessage.Result);
            });
        });
    }

    Refersh() {
        let cmd = this;
        let h = new Helper();
        h.Ajax('InLetter', 'Serach', h.GetPostData(), function (data) {
            cmd.setState({ isLoaded: true, Records: data });
        });
    }

    componentDidMount() {
     //   this.Refersh();
    }

    render() {
        if (this.state.isLoaded == false) {
            return LoadingBar();

        }
        else {
            return <FromBasic staticTitle=''>
                <InputTextBox caption="از تاریخ" columnName="start" model="start" customHelper={CustomHelper.isDate} size="33%"></InputTextBox>
                <InputTextBox caption="تا تاریخ" columnName="end" model="end" customHelper={CustomHelper.isDate} size="33%"></InputTextBox>
                <InputTextBox caption="شماره نامه" columnName="letNum" model="letNum"   size="33%"></InputTextBox>
                <InputTextBox caption="از" columnName="from" model="from" size="33%"></InputTextBox>
                <InputTextBox caption="به" columnName="to" model="to" size="33%"></InputTextBox>
                <InputTextBox caption="عنوان" columnName="title" model="title" size="33%"></InputTextBox>
                <SimpleButton title="نمایش " Icon="View" onClick={this.Refersh}></SimpleButton>
                <hr />


                <AddButton title='' entity='InLetter' /> <ProTable Records={this.state.Records} datasourcename='InLetters'>
                    <Column metaForDisplay={DataClass.InLetter.id} />
                    <Column metaForDisplay={DataClass.InLetter.From} />
                    <Column metaForDisplay={DataClass.InLetter.To} />
                    <Column metaForDisplay={DataClass.InLetter.LetterNum} />
                    <Column metaForDisplay={DataClass.InLetter.Title} />
                    <Column metaForDisplay={DataClass.InLetter.Context} />
                    <Column metaForDisplay={DataClass.InLetter.LetDate} />
                    <Column metaForDisplay={DataClass.InLetter.SaveTime} />
                    <Action caption="ضمیمه" Icon="Cat" type="Link" pageName="/Attachs/InLetter" columnName="id" />

                    <Action caption="ویرایش" type="Link" pageName="/InLetter/Edit" columnName="id" />


                    <Action caption="حذف" type="function" targetFun={this.Delete} />




                </ProTable>
            </FromBasic>
        }
    }



}


/* دریافت تمامی رکورد ها */
  


/* ویرایش */
function EditInLetter() {
    const queryS = useParams();
    return <AddInLetter id={queryS.id} />
}

/* درج و و یرایش رکورد */


export class AddInLetter extends React.Component {
    constructor(props) {
        super(props);
        this.props = props;
        this.id = props.id;
        this.submit = this.submit.bind(this);
    }
    submit() {
        let h = new Helper();
        let cmd = this;
        h.Validate();
        if (h.isValidate() == false) {
            return;
        }
        let id = (cmd.id == undefined ? -1 : cmd.id);
        let o = h.GetPostData();
        h.Ajax('InLetter', (cmd.id == '-1' ? 'Insert' : 'Update'), { Model: o, id: id }, function (data) {
            if (data.status == 200) {
                h.MessageBox(data.message, FixedMessage.Result);
                h.GoBack();
            }
            else {
                h.Error(data.message, FixedMessage.Result);

            }
        });
    }
    componentDidMount() {
        let h = new Helper();
        if (this.id != -1) {
            h.Ajax('InLetter', 'Get', { id: this.id }, function (data) {
                h.SetDataBack(data);
            });


        }
    }
    render() {
        return <FromSubmit submitBev={this.submit}>

            <InputBox meta={DataClass.InLetter.LetterNum} size='50%' />
            <InputBox meta={DataClass.InLetter.LetDate} size='50%' />
            <InputBox meta={DataClass.InLetter.From} size='50%' />
            <InputBox meta={DataClass.InLetter.To} size='50%' />
           
            <InputBox meta={DataClass.InLetter.Title} size='100%' />
            <InputTextBox caption="متن نامه" columnName="context" initvalue="context"   model="context"  size='100%' customHelper={CustomHelper.LongText} />
        
            


        </FromSubmit>

    }

}



export function LetterGenApp(props) {

    let routes = [
        <Route path="DefVars" element={<EnvVarMgt />}></Route>,
        <Route path="DefInputParameters" element={<InputParameterMgt />}></Route>,
        <Route path="BaseLetters" element={<BaseLetterMgt />} />,
        <Route path="Folders" element={<FolderMgt />} />,
        <Route path="BaseLetter/Add" element={<AddBaseLetter id="-1" />} />,
        <Route path="BaseLetter/Edit/:id" element={<EditBaseLetter />} />,
        <Route path="BaseLetter/CreateLetter/:id" element={<CreateLetter />} />,
         <Route path="Letters" element={<LetterSerach />} />,
           <Route path="Letter/Edit/:id" element={<EditLetter />} />,
           <Route path="InLetters" element={<InLetterMgt />} />,
<Route path="InLetter/Add" element={<AddInLetter id="-1" />} />,
                                           <Route path="InLetter/Edit/:id" element={<EditInLetter />} />


    ]
    return routes;
}